import Immutable from 'seamless-immutable'

import * as actionNames from './actionNames'

const initialState = Immutable.from({
  history: [],
  completions: [],
  chosenSuggestion: null,
  isFetching: false,
  searchInputFocused: false,
})

const searchInput = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actionNames.REQUEST_COMPLETIONS:
      return state.set('isFetching', true)
    case actionNames.RECEIVE_COMPLETIONS:
      if (error) {
        return state.set('completions', []).set('isFetching', false)
      }
      return state.set('completions', payload).set('isFetching', false)
    case actionNames.CLEAR_COMPLETIONS:
      return state
        .set('completions', [])
        .set('isFetching', false)
        .set('chosenSuggestion', null)
    case actionNames.CHOOSE_SUGGESTION:
      return state.set('chosenSuggestion', payload)
    case actionNames.RECEIVE_SEARCH_HISTORY:
    case actionNames.UPDATE_SEARCH_HISTORY:
      return state.merge({
        history: payload,
      })
    default:
      return state
  }
}

export default searchInput
